// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"e61db3cd","821":"decec801"}[chunkId] + ".chunk.js";
};